enum REDIRECT_TYPES {
  MATERIAL = 'material',
  LIST = 'list',
}

export default REDIRECT_TYPES;
